import { render, staticRenderFns } from "./my-account-card.vue?vue&type=template&id=b0af2e06&scoped=true"
import script from "./my-account-card.vue?vue&type=script&lang=js"
export * from "./my-account-card.vue?vue&type=script&lang=js"
import style0 from "./my-account-card.vue?vue&type=style&index=0&id=b0af2e06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0af2e06",
  null
  
)

export default component.exports